<template>

    <div class="mt-5">
        <h3>{{ lang('my-account.preferred-locale.header') }}</h3>

        <div class="form-group">
            <vue-select
                class="vselect-box"
                id="preferred_locale"
                label="name"
                v-model="locale"
                :clearable="false"
                :options="locales"
                :reduce="locale => locale.code"
            ></vue-select>

            <button
                class="btn btn-primary mt-3"
                :disabled="!canChangePreferredLocale"
                @click="changePreferredLocale"
            >
                {{ lang('my-account.preferred-locale.button') }}
            </button>
        </div>
    </div>

</template>

<script>

import vueSelect from "vue-select";

export default {

    components: {
        vueSelect
    },

    computed: {
        canChangePreferredLocale() {
            return this.locale !== this.preferredLocale &&
                this.posting === false;
        },

        locales() {
            let locales = [];

            for (const [code, name] of Object.entries(this.$page.props.locale.allowed)) {
                locales.push({code, name})
            }

            return locales;
        },
    },

    data() {
        return {
            locale:'',
            posting:false,
        }
    },

    methods: {
        changePreferredLocale() {
            if (!this.canChangePreferredLocale) {
                return;
            }

            this.posting = true;

            this.$inertia.post(this.route('auth.myaccount.details.preferred-locale.store'), {locale: this.locale}, {
                onFinish: () => this.posting = false,
            })
        },
    },

    mounted() {
        this.locale = JSON.parse(JSON.stringify(this.preferredLocale));
    },

    name:'MyAccountPreferredLocale',

    props: {
        preferredLocale: {
            required:true,
            type:String,
        },
    },

}

</script>
